<template>
  <li :class="{ 'last-milestone': isLastMilestone }">
    <div class="row">
      <div class="col-12 col-lg-7">
        <label class="sr-only">Key milestone</label>
        <quill-wrapper :config="quillConfig" @change="setDescription($event)" />
      </div>
      <div class="col-6 col-lg-2">
        <label class="sr-only">Key milestone start date</label>

        <flatpickr
          class="form-control"
          name="start_date"
          :config="dateConfig"
          v-model="stateStartDate"
          :class="[validationClasses('start_date', scope)]"
          :data-vv-scope="scope"
          placeholder="Add date"
          v-validate.disable="{ required: !isLastMilestone }"
        />
      </div>
      <div class="col-6 col-lg-2">
        <label class="sr-only">Key milestone end date</label>

        <flatpickr
          class="form-control"
          name="end_date"
          :data-vv-scope="scope"
          :config="endDateConfig"
          :class="[validationClasses('end_date', scope)]"
          v-model="stateEndDate"
          placeholder="Add date"
          v-validate.disable="{ required: !isLastMilestone }"
        />
      </div>
      <div class="col-auto d-flex align-items-center">
        <button
          v-if="!isLastMilestone"
          type="button"
          class="btn btn-link text-danger btn-delete-key-milestone"
          @click="confirmBeforeDeleting"
        >
          <font-awesome :icon="['far', 'trash-alt']"/>
          <span class="sr-only">Delete Key Milestones</span>
        </button>
      </div>
    </div><!-- /.row -->
  </li>
</template>

<script>
import { alert } from 'utils'
import { placementPerformanceObjectiveMethods, placementComputed } from 'vx/helpers'
import Flatpickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  inject: ['$validator'],

  props: {
    milestoneIndex: Number,
    objectiveIndex: Number,
    isLastMilestone: Boolean,
    milestone: {
      required: true,
      type: Object
    }
  },

  components: {
    Flatpickr
  },

  data () {
    return {
      dateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Z',
        disable: [(date) => {
          return moment(date).isBefore(
            moment(this.placement.start_date).add(-1, 'day')
          ) || moment(date).isAfter(
            moment(this.placement.end_date).add(1, 'day')
          )
        }]
      }
    }
  },

  watch: {
    stateStartDate (val) {
      if (moment(this.stateEndDate).isBefore(moment(val))) {
        this.stateEndDate = null
      }
    }
  },

  computed: {
    ...placementComputed,

    /**
     * https://support.codium.com.au/a/tickets/12145
     * cannot select an end date before start date
     *
     * @return object
     */
    endDateConfig () {
      return !this.stateStartDate ? this.dateConfig : Object.assign({}, this.dateConfig, {
        disable: [(date) => {
          return moment(date).isBefore(moment(this.stateStartDate)) || moment(date).isAfter(this.placement.end_date)
        }]
      })
    },

    scope () {
      return `objectives.${this.objectiveIndex}.milestones.${this.milestoneIndex}`
    },

    quillConfig () {
      return {
        options: { placeholder: 'Add key milestone...' },
        value: this.stateDescription
      }
    },

    stateDescription: {
      get () {
        return this.milestone.description
      },

      set (value) {
        this.setDescription(value)
      }
    },

    stateStartDate: {
      get () {
        return this.milestone.start_date
      },

      set (value) {
        this.setMilestoneProperty({
          milestoneIndex: this.milestoneIndex, objectiveIndex: this.objectiveIndex, property: 'start_date', value
        })
      }
    },

    stateEndDate: {
      get () {
        return this.milestone.end_date
      },

      set (value) {
        this.setMilestoneProperty({
          milestoneIndex: this.milestoneIndex, objectiveIndex: this.objectiveIndex, property: 'end_date', value
        })
      }
    }
  },

  methods: {
    ...placementPerformanceObjectiveMethods,

    setDescription (value) {
      this.setMilestoneProperty({
        milestoneIndex: this.milestoneIndex, objectiveIndex: this.objectiveIndex, property: 'description', value
      })
    },

    async confirmBeforeDeleting () {
      if (
        !await alert.confirm({
          title: 'Are you sure?',
          text: 'Are you sure you want to delete this key milestone.'
        })
      ) {
        return
      }

      this.deleteMilestone({
        objectiveIndex: this.objectiveIndex,
        milestoneIndex: this.milestoneIndex
      })
    }
  }
}
</script>
